import { render, staticRenderFns } from "./DialogDetailListEmail.vue?vue&type=template&id=4603d1e0&"
import script from "./DialogDetailListEmail.vue?vue&type=script&lang=js&"
export * from "./DialogDetailListEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports